window.addEventListener('popstate', function () {
  loadPage(window.location.href, false)
});

window.loadPage = function (url, pushState = true) {
  Notiflix.Block.circle('.content');
  if (pushState) { window.history.pushState('', '', url) }
  $.ajax({
    url: url,
    dataType: 'script',
    success: function(res){
      hideModal();
      Notiflix.Block.remove('.content');
      $('.content').html(res)
      initializeJS();
    }, 
    error: function(jqXHR){
      console.log(jqXHR)
    }
  })
}

$(document).on("click", "a", function(e){
  const href = $(this).attr("href")

  if (href.slice(0,4) == 'http') {
    return true
  }

  if (href == "javascript:void(0);" || href == "" || !href){
    return true;
  }

  e.preventDefault();
  setActiveSidebar({url: href, dom: $(this)})
  loadPage(href, true)
})

